export const getBaseURL = () =>
  process.env.REACT_APP_SERVER_BASE_URL || 'http://grant-connect-dev.herokuapp.com/'

export const reCaptchaKey = '6LdiFWcUAAAAAPkIywdkwENMC_gDUeUJ9IrCZqee'

export const userflowToken = 'ct_ujlibuvdwza5hcdr2hcd4x6s7e'

// Feature flags
export const enableSubscriberInfoDashboard =
  process.env.REACT_APP_ENABLE_SUBSCRIBER_INFO_DASHBOARD === 'true'
export const enableSearchFormFacetFuzzyMatching =
  process.env.REACT_APP_ENABLE_SEARCH_FORM_FACET_FUZZY_MATCHING === 'true'
export const enableFunderPillsColoring =
  process.env.REACT_APP_ENABLE_FUNDER_PILLS_COLORING === 'true'
export const enableProfilePageExplorerLinks =
  process.env.REACT_APP_ENABLE_PROFILE_PAGE_EXPLORER_LINKS === 'true'
